import { nui } from 'lib/nodes-ui';
import { sha1 } from 'lib/shared-util';

class SitePreviewUI {

  setCanvas(canvas) {
    this.canvas = canvas;
    this.operation = canvas.operation;
    this.store = canvas.store;

    this.urlPreviews = {};

    const { urlPreviews } = JSON.parse(unescape(window.escaped_map_data));
    if (urlPreviews) {
      for (const el of urlPreviews) {
        this.urlPreviews[el.url] = el;
      }
    }
  }

  getLinkStates({ nodeId, url }) {
    const node = this.store.getNode(nodeId);
    return node.linkStates[sha1(url)];
  };

  getLinkIsHidden({ nodeId, url }) {
    const linkStates = this.getLinkStates({ nodeId, url });

    //if we're an old node with no link state, hide the preview
    if (!linkStates) return true;

    return linkStates.isHidden;
  };

  getLinkIsCollapsed({ nodeId, url }) {
    const linkStates = this.getLinkStates({ nodeId, url });
    if (!linkStates) return false;
    return linkStates.isCollapsed;
  };

  setLinkState({ nodeTag, url, state, stateType, skipOperation }) {
    const nodeId = nodeTag.id;
    const node = this.store.getNode(nodeId);
    this.resetLinkStates({ nodeId, url });

    node.linkStates[sha1(url)][stateType] = state;

    nodeTag.refs.sitePreviewer.update();

    if (skipOperation) return;

    const messages = [];

    const { prevNodePositions, nodePositions } = nui.fixOverlaps({
      nodeTag,
      fromExpand: !state,
      fromCollapse: state,
      allowedDirections: ['right', 'left', 'down'],
    });

    if (nodePositions.length) {
      messages.push(this.operation.messages.updateNodePositions({
        prevNodePositions,
        nodePositions,
        prevLinkAngles: [],
        linkAngles: [],
      }));
    }

    const op = stateType === 'isHidden' ? 'toggleLinkPreviewHidden' : 'toggleLinkPreviewCollapsed';
    messages.push(
      this.operation.messages[op]({
        nodeId,
        [stateType]: state,
        url,
        mapId: window.map_id,
      })
    );

    this.operation.batchOperation({
      messages,
      onFailure: (err) => {
        console.log(`batchOperation failure: ${err}`);
      }
    });
  }

  setLinkIsHidden({ nodeTag, url, isHidden, skipOperation }) {
    this.setLinkState({
      nodeTag,
      url,
      state: isHidden,
      stateType: 'isHidden',
      skipOperation
    });
  };

  setLinkIsCollapsed({ nodeTag, url, isCollapsed, skipOperation }) {
    this.setLinkState({
      nodeTag,
      url,
      state: isCollapsed,
      stateType: 'isCollapsed',
      skipOperation
    });
  };

  resetLinkStates({ nodeId, url }) {
    const node = this.store.getNode(nodeId);
    const linkStates = this.getLinkStates({ nodeId, url });

    if (!linkStates) {
      node.linkStates[sha1(url)] = {};
    }
  };
}
const spUI = new SitePreviewUI();

export { SitePreviewUI, spUI };



// WEBPACK FOOTER //
// ./starling/src/lib/site-preview-ui.js